import { useState } from "react";
import QuizPage from "./components/quiz-page";
import Results from "./components/results";
import UseQuestions from "./useQuestions";

function Quiz() {
  const [questions, load] = UseQuestions();
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentState, setCurrentState] = useState("question");
  const [currentSelectedAnswer, setCurrentSelectedAnswer] = useState(-1);
  const [numberOfCorrectAnswers, setNumberOfCorrectAnswers] = useState(0);

  if (questions.length === 0) return <div>Loading...</div>;
  const question = questions[currentQuestion];

  function onSelected(index) {
    setCurrentSelectedAnswer(index);
    if (index === question.correctIndex) {
      setNumberOfCorrectAnswers(numberOfCorrectAnswers + 1);
      setCurrentState("correct");
    } else {
      setCurrentState("wrong");
    }
  }
  function onNext() {
    if (currentQuestion < questions.length - 1) {
      setCurrentState("question");
      setCurrentSelectedAnswer(-1);
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setCurrentState("results");
    }
  }

  function onRetry() {
    setCurrentState("question");
    setCurrentQuestion(0);
    setCurrentSelectedAnswer(-1);
    setNumberOfCorrectAnswers(0);
    load();
  }

  if (currentState === "results") {
    const isGood = numberOfCorrectAnswers / questions.length >= 0.75;

    return (
      <Results
        mode={isGood ? "good" : "bad"}
        numberOfQuestion={questions.length}
        numberOfCorrectAnswers={numberOfCorrectAnswers}
        onRetry={onRetry}
      ></Results>
    );
  } else {
    return (
      <QuizPage
        question={question}
        onSelected={onSelected}
        mode={currentState}
        selectedAnswer={currentSelectedAnswer}
        onNext={onNext}
        numberOfQuestions={questions.length}
        currentQuestion={currentQuestion}
      ></QuizPage>
    );
  }
}

export default Quiz;
